import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CodeItem {
	codeType: string
	searchKey: string | null
	value: number
	label: string
	searchParam: string | null
}

interface KeyValueItem {
	value: number
	label: string
}

interface CodeState {
	codes: Record<string, CodeItem[]>
	initialized: boolean

	// 设置所有配置数据
	setAllCodes: (data: CodeItem[]) => void

	// 根据 codeType 获取选项
	getOptionsByType: (codeType: string) => KeyValueItem[]

	// 获取单个选项
	getOptionByTypeAndValue: (codeType: string, value: number) => CodeItem | undefined

	// 获取所有可用的 codeType
	getAllCodeTypes: () => string[]

	// 清空数据
	clear: () => void
}

export const useCodeStore = create<CodeState>()(
	persist(
		(set, get) => ({
			codes: {},
			initialized: false,

			setAllCodes: (data: CodeItem[]) => {
				// 按 codeType 分组
				const groupedCodes: Record<string, CodeItem[]> = {}
				data.forEach((item) => {
					if (!groupedCodes[item.codeType]) {
						groupedCodes[item.codeType] = []
					}
					groupedCodes[item.codeType].push(item)
				})

				set({ codes: groupedCodes, initialized: true })
			},

			getOptionsByType: (codeType: string) => {
				const items = get().codes[codeType] || []
				return items.map((item) => ({
					value: item.value,
					label: item.label
				}))
			},

			getOptionByTypeAndValue: (codeType: string, value: number) => {
				const items = get().codes[codeType] || []
				return items.find((item) => item.value === value)
			},

			getAllCodeTypes: () => {
				return Object.keys(get().codes)
			},

			clear: () => set({ codes: {}, initialized: false })
		}),
		{
			name: 'code-store', // 持久化存储的键名
			partialize: (state) => ({
				codes: state.codes,
				initialized: state.initialized
			}) // 只持久化特定字段
		}
	)
)
